import PropTypes from 'prop-types';

export const GUEST_LOGIN_ALLOWED_PATH = /^\/(sitepass|cart)/;

export const ACCOUNT_PROPS = PropTypes.shape({
    access_token: PropTypes.string,
    expiration: PropTypes.string,
    account: PropTypes.shape({
        account_id: PropTypes.string,
        cell_phone: PropTypes.string,
        email: PropTypes.string,
        emergency_content: PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string
        }),
        favorites: PropTypes.array,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string
        }),
        home_phone: PropTypes.string,
        is_commercial_account: PropTypes.bool,
        last_name: PropTypes.string,
        legacy_account: PropTypes.bool,
        newsletter_alerts: PropTypes.bool,
        passes: PropTypes.array,
        phone_alerts: PropTypes.bool,
        profile_picture_id: PropTypes.string,
        sms_alerts: PropTypes.bool,
        trip_perferences: PropTypes.array
    })
});

export const CSR_ACCOUNT_PROPS = PropTypes.shape({
    access_token: PropTypes.string,
    expiration: PropTypes.string,
    name: PropTypes.string
});

export const CART_PROPS = PropTypes.shape({
    account_id: PropTypes.string,
    discount: PropTypes.string,
    err_message: PropTypes.string,
    expiration: PropTypes.string,
    hasError: PropTypes.bool,
    reservations: PropTypes.array,
    showSessionWarning: PropTypes.bool,
    showTimer: PropTypes.bool,
    subtotal: PropTypes.string,
    tax: PropTypes.string,
    total: PropTypes.string
});

export const CART_HEADER_PROPS = PropTypes.shape({
    expiration: PropTypes.string,
    showTimer: PropTypes.bool,
    reservation_count: PropTypes.number
});

export const LOGIN_NOTICE_PROPS = PropTypes.shape({
    notice_body: PropTypes.string,
    notice_enabled: PropTypes.bool,
    notice_title: PropTypes.string
});

export const ANNOUNCEMENT_PROPS = PropTypes.shape({
    banner_background_color: PropTypes.string,
    banner_body: PropTypes.string,
    banner_body_color: PropTypes.string,
    banner_enable_hiding: PropTypes.bool,
    banner_enabled: PropTypes.bool,
    banner_homepage_only: PropTypes.bool,
    banner_image: PropTypes.string,
    banner_key: PropTypes.string,
    banner_link: PropTypes.string,
    banner_link_button_title: PropTypes.string,
    banner_title: PropTypes.string,
    banner_photo_credit: PropTypes.string
});

export const ANNOUNCEMENT_DEFAULT_PROPS = PropTypes.shape({
    banner_background_color: null,
    banner_body: "",
    banner_body_color: "",
    banner_enable_hiding: true,
    banner_enabled: false,
    banner_homepage_only: false,
    banner_image: "",
    banner_key: "default_banner_key",
    banner_link: "",
    banner_link_button_title: "",
    banner_title: "",
    banner_photo_credit: ""
});
